import { getInitialTableData } from '../components/Table/utils/data'
import { ElementalTypeEnum } from '../types/elemental'
import { useCreateElemental } from './mutations/elemetal/useCreateElemental'

export function useCreateForm() {
  const { mutate, isPending } = useCreateElemental()
  const user = useUser()
  const router = useRouter()

  const createForm = async (onComplete?: () => void) => {
    if (!user.value)
      return router.push(useGetLoginURL())

    const table = getInitialTableData()
    const title = `Form ${formatDateCST(new Date())}`

    // Get runtime config inside the async function to ensure it's properly initialized
    const runtimeConfig = useRuntimeConfig()

    mutate(
      {
        elemental: {
          title,
          rows: [],
          elementalTypeId: ElementalTypeEnum.Table,
          isPrivate: true,
          columns: [],
          data: table,
          isPremium: false,
          description: '',
          attachments: [],
          images: {
            cover: [],
            output: [],
          },
          url: '',
        },
        elementalType: ElementalTypeEnum.Table,
      },
      {
        onSuccess: (elemental) => {
          if (elemental?.id) {
            // Falls back to production URL if not configured
            const formBuilderUrl = runtimeConfig.public.spWebAppUrl
            // Open form-builder with the table ID
            window.open(`${formBuilderUrl}/forms/${elemental.id}`, '_blank')
          }
          // Call the completion callback if provided
          onComplete?.()
        },
      },
    )
  }

  return {
    createForm,
    isPending,
  }
}
